/**
 * Seller pricing constants extracted from pricing-page.tsx
 * Used across components to maintain consistency
 */

export const SELLER_PRICING = {
	// Base fee percentage
	feePercentage: 2,

	// Minimum fee amount
	minimumFee: 100000, // ₹1,00,000
	maximumFee: 500000,

	// Special pricing caps
	specialPricing: [
		{
			minValue: 25000000, // ₹2.5 cr and above
			cap: 500000, // ₹5,00,000
			label: "Properties worth ₹2.5 cr and more, capped at ₹5,00,000",
		},
		// {
		// 	minValue: 15900000, // ₹1.59 cr
		// 	maxValue: 49999999, // up to ₹5 cr
		// 	cap: 300000, // ₹3,00,000
		// 	label: "Properties worth ₹1.59 cr to ₹5 cr, capped at ₹3,00,000",
		// },
	],

	// Fee calculation examples
	examples: [
		{
			salePrice: 4500000, // ₹45 Lakh
			salePriceLabel: "₹45 Lakh",
			fee: 100000, // ₹1 lakh (minimum fee applies)
			feeLabel: "₹1 lakh",
		},
		{
			salePrice: 8000000, // ₹80 Lakh
			salePriceLabel: "₹80 Lakh",
			fee: 160000, // 2% of 80 Lakh
			feeLabel: "₹1.6 Lakh",
		},
		{
			salePrice: 12000000, // ₹1.2 Crore
			salePriceLabel: "₹1.2 Crore",
			fee: 240000, // 2% of 1.2 crore
			feeLabel: "₹2.4 Lakh",
		},
		{
			salePrice: 30000000,
			salePriceLabel: "₹3 Crore",
			fee: 500000, // Capped at ₹5 lakh for properties ₹2.5cr+
			feeLabel: "₹5 Lakh",
		},
	],
} as const;

/**
 * Calculate seller fee based on sale price
 * @param salePrice - Sale price in rupees
 * @returns Calculated fee amount
 */
export function calculateSellerFee(salePrice: number): number {
	const baseCalculation = (salePrice * SELLER_PRICING.feePercentage) / 100;

	// Apply special pricing caps
	// for (const pricing of SELLER_PRICING.specialPricing) {
	// 	if (pricing.minValue && salePrice >= pricing.minValue) {
	// 		if (!("maxValue" in pricing) || salePrice <= pricing.maxValue) {
	// 			return Math.min(baseCalculation, pricing.cap);
	// 		}
	// 	}
	// }

	// Apply minimum fee
	return Math.min(Math.max(baseCalculation, SELLER_PRICING.minimumFee), SELLER_PRICING.maximumFee);
}
